import * as tslib_1 from "tslib";
import { Rectangle, AbstractMethodError } from "@awayjs/core";
import { ImageBase } from "../image/ImageBase";
import { ImageUtils } from "../utils/ImageUtils";
var Image2D = (function (_super) {
    tslib_1.__extends(Image2D, _super);
    /**
     *
     */
    function Image2D(width, height, powerOfTwo) {
        if (powerOfTwo === void 0) { powerOfTwo = true; }
        var _this = _super.call(this) || this;
        _this._powerOfTwo = true;
        _this._rect = new Rectangle(0, 0, Math.round(width), Math.round(height));
        _this._powerOfTwo = powerOfTwo;
        _this._testDimensions();
        return _this;
    }
    Object.defineProperty(Image2D.prototype, "assetType", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return Image2D.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Image2D.prototype, "height", {
        /**
         * The height of the image in pixels.
         */
        get: function () {
            return this._rect.height;
        },
        set: function (value) {
            this._setSize(this._rect.width, value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Image2D.prototype, "rect", {
        /**
         * The rectangle that defines the size and location of the bitmap image. The
         * top and left of the rectangle are 0; the width and height are equal to the
         * width and height in pixels of the BitmapData object.
         */
        get: function () {
            return this._rect;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Image2D.prototype, "width", {
        /**
         * The width of the bitmap image in pixels.
         */
        get: function () {
            return this._rect.width;
        },
        set: function (value) {
            this._setSize(value, this._rect.height);
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @param width
     * @param height
     * @private
     */
    Image2D.prototype._setSize = function (width, height) {
        width = Math.round(width);
        height = Math.round(height);
        if (this._rect.width == width && this._rect.height == height)
            return;
        this.clear();
        this._rect.width = width;
        this._rect.height = height;
        this._testDimensions();
    };
    /**
     *
     * @private
     */
    Image2D.prototype._testDimensions = function () {
        if (this._powerOfTwo && (!ImageUtils.isDimensionValid(this._rect.width) || !ImageUtils.isDimensionValid(this._rect.height)))
            throw new Error("Invalid dimension: Width and height must be power of 2 and cannot exceed 2048");
    };
    Object.defineProperty(Image2D.prototype, "powerOfTwo", {
        /**
         * Enable POT texture size validation
         * @returns {boolean}
         */
        get: function () {
            return this._powerOfTwo;
        },
        set: function (value) {
            if (this._powerOfTwo == value)
                return;
            this._powerOfTwo = value;
            this._testDimensions();
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @returns {ImageData}
     */
    Image2D.prototype.getImageData = function () {
        throw new AbstractMethodError();
    };
    return Image2D;
}(ImageBase));
export { Image2D };
Image2D.assetType = "[image Image2D]";



// WEBPACK FOOTER //
// ../dist/lib/image/Image2D.js